import { T } from 'gt-react';
import type { DepositBatchSummary } from '@erp/rpc';
import { Badge } from '@/components/ui/badge';

export function DepositStatusBadge({
  batch,
}: {
  batch: Pick<DepositBatchSummary, 'status' | 'processingCount'>;
}) {
  if (batch.status === 'submitted') {
    return (
      <Badge variant="success">
        <T context="check deposit status">Submitted</T>
      </Badge>
    );
  }
  if (batch.processingCount > 0) {
    return (
      <Badge variant="secondary">
        <T context="check deposit status, files still being read">
          Reading files
        </T>
      </Badge>
    );
  }
  return (
    <Badge variant="outline">
      <T context="check deposit status, not yet submitted">Draft</T>
    </Badge>
  );
}
